<template>
  <div>
    <a-form-model :model="informationList" :rules="rules" ref="informationRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
    >
      <div class="title">
        <span>基本信息</span>
      </div>
      <div class="userContainer">
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="企业名称"
              prop="companyName"
            >
              <span>{{ propRowData.companyName }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              :label-col="{ span: 9 }"
              class="model_span_form"
              :wrapper-col="{ span: 15 }"
              label="企业地址"
              prop="companyName"
            >
              <span>{{ propRowData.address }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <div class="line">
          <a-row>
            <!-- <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="选择项目"
                prop="categoryName"
                :rules="{
                  required: true,
                  message: '请选择项目名称',
                  trigger: 'change',
                }"
              >
                <a-select
                  allowClear
                  placeholder="请选择项目"
                  v-model="informationList.categoryName"
                  @change="changeCategory"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                  >
                    {{ item.categoryName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col> -->
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="选择子项目"
                prop="projectCategory"
                :rules="{
                  required: true,
                  message: '请选择子项目',
                  trigger: 'change',
                }"
              >
                <a-select  mode="multiple" allowClear placeholder="请选择子项目"  v-model="informationList.projectCategory" @change="changeProject">
                  <a-select-option :value="item.id" v-for="(item, index) in datalist" :key="index">
                    {{ item.abbreviationCategory }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                :label-col="{ span: 9 }"
                class="model_span_form"
                :wrapper-col="{ span: 15 }"
                label="行业"
                
                prop="industryName"
                :rules="{
                  required: true,
                  message: '请输入行业',
                  trigger: 'change',
                }"
              >
                <a-select allowClear placeholder="所属行业" v-model="informationList.industryName" @change="transmitData">
                  <a-select-option :value="item.id" v-for="(item, index) in industryList" :key="index">
                    {{ item.industryName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </div>
         
      </div>
    </a-form-model>
     
  </div>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'
import { getCustomer, items_list, itemsChildren_list,  industryInfo, usreInfo} from '@/api/Industry'

export default {
  props: ['propRowData',
  'UUID',
  'rowData'],
  data() {
    return {
    //   generateVisible: false,
      industryList: [],
      informationList: [],
      customerInformation: {},
      categoryNameList: {},
      datalist: {}
    }
  },
  created() {
      this.informationList.categoryName = this.rowData.categoryName
          this.informationList.abbreviation = this.rowData.abbreviation
      itemsChildren_list({
        parentId: this.rowData.id
      }).then((res) => {
          this.datalist = res.data

      })
      
    // //获取客服信息
    // getCustomer().then((res) => {
    //   if (res.code == 200) {
    //     this.customerInformation = res.data
    //     console.log(this.customerInformation, 'this.customerInformation=================')
    //   } else {
    //     this.$message.error('获取客服信息失败！')
    //   }
    // })
    //查询报价检测项目列表
    items_list().then((res) => {
        if (res.code == 200) {
         this.categoryNameList = res.data
      } else {
        this.$message.error('查询报价检测项目列表失败！')
      }
     
    })
    //获取行业列表
    industryInfo({
      projectId: this.rowData.id
    }).then((res) => {
        if (res.code == 200) {
         this.industryList = res.data
      } else {
        this.$message.error('获取获取行业列表失败！')
      }
        
    })
    //获取当前用户的基本信息
    // usreInfo({
		// userId: this.$store.getters.userInfo.userId
    //     }).then(res => {
    //       console.log(res, 'informationList=============================')
    //         this.informationList.userName = res.userName
    //         this.informationList.telephone = res.phonenumber
    //         this.informationList.email = res.email
    //     })



  },
  // watch: {
  //   {
        
  //   }

  // },
  methods: {
    //向父组件传递当前表单数据
    transmitData(e) {
       this.industryList.forEach(item => {
        if (item.id == e) {
          console.log(item, 'item=====================')
          this.informationList.industryName = item.industryName
          Object.assign(this.informationList, {
            categoryName: this.rowData.categoryName
          })
          // Object.assign(this.informationList, {
          //        abbreviation: item.abbreviationCategory
          // })
            this.$emit("getIndustry", item)
        }
        
      });

      console.log(this.informationList, 'this.informationList333333333')
      //  this.$emit("transmit", this.informationList)
      // this.$emit("transmit", this.informationList)

    },
    changeProject(e) {
      // this.datalist.forEach(item => {
      //   console.log(this.datalist, 'this.datalist=====================')
      //   if (item.id == e) {
      //     this.informationList.projectCategory = item.projectCategory
      //   }
        
      // })
      this.$emit("transmit", {
       informationList: this.informationList,
       datalist:  this.datalist
      })

    },
    changeCategory(e) {
      this.categoryNameList.forEach(item => {
        console.log(this.categoryNameList, 'this.categoryNameList=====================')
        if (item.id == e) {
          this.informationList.categoryName = this.rowData.categoryName
          this.informationList.abbreviation = this.rowData.abbreviation
        }
        
      });
      
      itemsChildren_list({
        parentId: this.rowData.id
      }).then((res) => {
          this.datalist = res.data

      })
    },
    //关闭弹窗事件
    // cancleModel() {
    //     this.generateVisible = false
    //     this.$emit("visibleState", this.generateVisible)
    //     // console.log

    // }
  },
//   取消事件
  cancle() {
    //   this.generateVisible = false
      //清除表单

  },
  //确定事件
  deterMine() {

  }
}
</script>
<style >
.userContainer {
  background-color: #fff;
  padding: 15px 5px;
  border-radius: 10px;
  padding-left: 10px;
}
.userDetailContaier {
  padding: 0px 24px 24px 24px;
  background-color: #fff;
}
.ant-modal-body {
  background-color: #f8f8f8 !important;
}
.title {
  font-size: 18px;
}
.line {
  border-top: 1px solid rgb(186, 184, 184);
  border-bottom: 1px solid rgb(186, 184, 184);
  padding: 20px 0;
  margin: 20px 0;
}
.footerButton {
  padding-bottom: 10px;
  padding-left: 80% ;
}
</style>
